import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { State } from 'redux/initialState';

import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import { setModal } from 'modules/_shared/redux/modalActions';
import { useGetPlanSectionPermissions } from 'modules/beneficiaries/hooks/useGetPlanSectionPermissions';

type BeneficiaryPlanHeaderProps = {
  rows: any;
  menuOptions: any;
};

const BeneficiaryPlanHeader: FC<BeneficiaryPlanHeaderProps> = ({
  rows,
  menuOptions,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const user = useSelector((state: State) => state?.user);
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { isAdmin, isReadOnly } = useGetPlanSectionPermissions().data;

  const title = `${actualSociety.name} ${t('HavePlans', {
    count: rows?.length,
  })}`;

  return (
    <>
      <div className="nk-block-head-content">
        <h3 className="nk-block-title page-title">{actualSociety.name}</h3>
        <p />
      </div>

      <div className="nk-block-head">
        <div className="nk-block-between">
          <div className="nk-block-head-content">
            <h3 className="nk-block-title page-title">
              {t('StockPhantomPlans')}
            </h3>
            <div className="nk-block-des text-soft">
              <p>{title}</p>
            </div>
          </div>

          <div className="nk-block-head-content">
            <div className="toggle-wrap nk-block-tools-toggle">
              <a
                className="btn btn-icon btn-trigger toggle-expand mr-n1"
                data-target="pageMenu"
                aria-label="link"
              >
                <em className="icon ni ni-menu-alt-r" />
              </a>
              <div className="toggle-expand-content" data-content="pageMenu">
                <ul className="nk-block-tools g-3">
                  <li>
                    <Link
                      to={`/resumen-planes/${actualSociety['_id']}`}
                      className="btn btn-outline-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <em className="icon ni ni-external" />
                      <span>{t('SummaryView')}</span>
                    </Link>
                  </li>

                  {isAdmin ? (
                    <li>
                      <OperationMenuDots
                        menuOptions={menuOptions}
                        handleModal={(Modal: any) =>
                          dispatch(
                            setModal(
                              <Modal
                                user={user}
                                societyId={actualSociety['_id']}
                              />
                            )
                          )
                        }
                        disabled={isReadOnly}
                      />
                    </li>
                  ) : (
                    <> </>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeneficiaryPlanHeader;
